import { useGridDefinitions } from "@/controls/ag-grid/components/GridDefinitions";
import { CenteredLazyLoading } from "@/controls/LazyLoading";
import { CampaignResponse } from "@/pages/mill/schedule/models/CampaignReponse";
import { Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";

import { useHeatsTableData } from "../hooks/useHeatsTableData";
import { MechanicalResultsModal } from "./MechanicalResultsModal";

type Props = {
	rows: CampaignResponse[];
	isLoading: boolean;
};

export const PendingHeatsTable = ({ rows, isLoading }: Props) => {
	const [heatToView, setHeatToView] = useState<CampaignResponse | null>(null);

	const { columnDefs } = useHeatsTableData({
		onViewMechanicalResults: setHeatToView,
	});
	const { defaultColDef } = useGridDefinitions({});

	return (
		<>
			<Paper
				elevation={2}
				sx={{
					height: "30vh",
					width: "100%",
					"& .ag-cell": { fontSize: 11 },
				}}
			>
				<AgGridReact<CampaignResponse>
					loading={isLoading}
					rowData={rows}
					columnDefs={columnDefs}
					defaultColDef={defaultColDef}
					rowHeight={32}
					headerHeight={34}
					animateRows
					loadingOverlayComponent={CenteredLazyLoading}
					getRowId={(params) => String(params.data.CampaignId)}
				/>
			</Paper>

			<MechanicalResultsModal
				heat={heatToView}
				onHide={() => setHeatToView(null)}
			/>
		</>
	);
};
